import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const GOLD = '#D4AF37';

  return (
    <div className="min-h-screen" style={{ background: '#05050A' }} data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-white/40 hover:text-[#D4AF37] transition-colors mb-8 font-['Outfit'] text-sm"
          data-testid="privacy-back-btn"
        >
          <ArrowLeft size={18} /> Back
        </button>

        <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl font-light text-white mb-2">
          Privacy <span style={{ color: GOLD }}>Policy</span>
        </h1>
        <p className="font-['Outfit'] text-xs text-white/30 uppercase tracking-[0.2em] mb-10">Last updated: April 2026</p>

        <div className="space-y-8 font-['Outfit'] text-sm text-white/60 leading-relaxed">
          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">1. Information We Collect</h2>
            <p>When you use Bliss App, we collect information you provide directly: your email address, nickname, profile picture, and content you upload (photos, videos, notes). We also collect usage data to improve the app experience.</p>
          </section>

          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">2. How We Use Your Information</h2>
            <p>Your information is used to provide and maintain the Bliss App service, authenticate your account, display your content within the app, and send notifications you have opted into. We do not sell your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">3. Data Storage</h2>
            <p>Your uploaded media is stored securely using Firebase Cloud Storage. Account data is stored in our encrypted databases. We implement industry-standard security measures to protect your information.</p>
          </section>

          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">4. Third-Party Services</h2>
            <p>We use Firebase (Google) for authentication and storage, and may display advertisements through Google AdMob. These services have their own privacy policies governing data use.</p>
          </section>

          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">5. Your Rights</h2>
            <p>You may request deletion of your account and all associated data at any time by contacting the administrator. You can update your profile information directly within the app.</p>
          </section>

          <section>
            <h2 className="font-['Cormorant_Garamond'] text-xl text-white/80 mb-3">6. Contact</h2>
            <p>For privacy-related inquiries, please contact us through the app or email the administrator at blissapp.admin@gmail.com.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.05]">
          <span className="font-['Cormorant_Garamond'] text-base text-white/40">
            <span style={{ color: GOLD }}>Bliss</span> App <span className="text-white/15 mx-2">|</span>
            <span className="font-['Outfit'] text-[10px] uppercase tracking-[0.2em] text-white/20">Imperium Core</span>
          </span>
        </div>
      </div>
    </div>
  );
}
